(() => {
  // Publish the sticky header height so page toolbars can pin directly beneath
  // it without hard-coding a number that breaks when the bar wraps.
  // Shopify renders section groups as a class on each section wrapper, not as
  // a single element with a matching id.
  const group = document.querySelector('.shopify-section-group-header-group');

  if (group) {
    const publishHeight = () => {
      document.documentElement.style.setProperty('--header-h', `${Math.round(group.offsetHeight)}px`);
    };
    publishHeight();
    window.addEventListener('resize', publishHeight);
    if ('ResizeObserver' in window) new ResizeObserver(publishHeight).observe(group);
  }

  const triggers = document.querySelectorAll('[data-mega-trigger]');
  const panels = document.querySelectorAll('[data-mega-panel]');
  const drawer = document.getElementById('nav-drawer');
  const burger = document.querySelector('[data-drawer-toggle]');

  const closeMega = () => {
    panels.forEach((panel) => { panel.hidden = true; });
    triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
  };

  triggers.forEach((trigger) => {
    const panel = document.querySelector(`[data-mega-panel="${trigger.dataset.megaTrigger}"]`);
    if (!panel) return;

    const open = () => {
      closeMega();
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    };

    // The trigger is a link, so a click navigates to the department. Only
    // pointer and keyboard focus open the panel.
    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('focus', open);
    panel.addEventListener('mouseleave', closeMega);
  });

  // Close the mega menu when the pointer leaves the header entirely.
  const header = document.querySelector('.site-header');
  if (header) header.addEventListener('mouseleave', closeMega);

  const openDrawer = () => {
    if (!drawer) return;
    drawer.hidden = false;
    burger?.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    drawer.querySelector('[data-drawer-close]')?.focus();
  };

  const closeDrawer = () => {
    if (!drawer) return;
    drawer.hidden = true;
    burger?.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    burger?.focus();
  };

  burger?.addEventListener('click', openDrawer);
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-drawer-close]')) closeDrawer();
  });

  // Utility dropdowns are plain <details>, so they open without JS. This only
  // adds what a details element does not do on its own: shut when the shopper
  // clicks elsewhere or presses Escape.
  const drops = [...document.querySelectorAll('[data-utility-drop]')];

  const closeDrops = () => drops.forEach((drop) => { drop.open = false; });

  drops.forEach((drop) => {
    drop.addEventListener('toggle', () => {
      if (!drop.open) return;
      drops.filter((other) => other !== drop).forEach((other) => { other.open = false; });
    });
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-utility-drop]')) closeDrops();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeMega();
    closeDrops();
    if (drawer && !drawer.hidden) closeDrawer();
  });
})();
